module.exports = __webpack_public_path__ + "img/blog-1.679f7269.webp";